import EventHandler from './dom/event-handler';
import SelectorEngine from './dom/selector-engine';
import Dropdown from './dropdown';

class NavbarFixed {
    /**
     * @param {HTMLElement} mainnav 
     */
    constructor (mainnav) {
        this.mainnav = mainnav;
        /** @type {Dropdown[]} */
        this.dropdownElems = SelectorEngine.find("#" + mainnav.id + " [data-bs-toggle=\"dropdown\"]");
        this.scrollPos = null;
        /** @type {HTMLDivElement} */
        this.mainnavItems = SelectorEngine.findOne("#mainnav-items");

        for (let index = 0; index < this.dropdownElems.length; index++) {
            this.dropdownElems[index] = Dropdown.getOrCreateInstance(this.dropdownElems[index]);
        }

        const intersectionOptions = {
            root: null,
            rootMargin: "0px",
            threshold: 0
        };

        const observer = new IntersectionObserver(entries => this.observerCallback(entries, this.mainnav), intersectionOptions);
        observer.observe(mainnav.parentElement);

        document.addEventListener("scroll", () => this.scrollEvent());

        this.offcanvasFull();
    }

    /**
     * @param {IntersectionObserverEntry[]} entries
     * @param {HTMLElement} mainnav
     */
    observerCallback (entries, mainnav) {
        entries.forEach(function(entry) {
            mainnav.classList.toggle("ome-fixed", !entry.isIntersecting);
            if (entry.isIntersecting) {
                mainnav.classList.add("ome-fixed-hide");
            }
        });
    }

    scrollEvent() {
        if (this.scrollPos !== null && this.mainnav.classList.contains("ome-fixed")) {
            this.mainnav.classList.toggle("ome-fixed-hide", window.scrollY > this.scrollPos);

            if (window.scrollY < this.scrollPos) {
                this.dropdownElems.forEach(elem => {
                    elem.hide();
                });
            }
        }
        this.scrollPos = window.scrollY;
    }

    offcanvasFull() {
        this.mainnavItems.addEventListener("show.bs.offcanvas", () => {
            this.mainnav.classList.add("ome-fixed-offscreen");
        });
        this.mainnavItems.addEventListener("hidden.bs.offcanvas", () => {
            this.mainnav.classList.remove("ome-fixed-offscreen");
        });
    }
}

EventHandler.one(document, 'DOMContentLoaded', () => {
    new NavbarFixed(SelectorEngine.findOne('#mainnav'));
});

export default NavbarFixed;
